// extracted by mini-css-extract-plugin
module.exports = {"button":"K","isRental":"L","lightBGPrimary":"M","secondary":"N","iconButton":"O","darkBGSecondary":"P","warning":"Q","outlined":"R"};